module.exports = __webpack_public_path__ + "img/pizza_icon.20f03ccc.svg";